import { render, staticRenderFns } from "./Etiquetas.vue?vue&type=template&id=df4a4fd6&"
import script from "./Etiquetas.vue?vue&type=script&lang=ts&"
export * from "./Etiquetas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('df4a4fd6', component.options)
    } else {
      api.reload('df4a4fd6', component.options)
    }
    module.hot.accept("./Etiquetas.vue?vue&type=template&id=df4a4fd6&", function () {
      api.rerender('df4a4fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/Etiquetas.vue"
export default component.exports